import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#ED174C",
        secondary: "#1F3F78",
        thirdary: "798E9A",
        //couleurXYZ: '#114488',
      },
    },
  },
});
